import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import ProductCard from './ProductCard';

interface ProductSectionProps {
    products: any[];
    isLoading: boolean;
    isLoadingMore: boolean;
    hasMoreProducts: boolean;
    totalElements: number;
    loadMoreProducts: () => void;
}

const ProductSection: React.FC<ProductSectionProps> = ({
                                                           products,
                                                           isLoading,
                                                           isLoadingMore,
                                                           hasMoreProducts,
                                                           totalElements,
                                                           loadMoreProducts,
                                                       }) => {
    return (
        <Box className="section" sx={{ marginTop: 0 }}>
            {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: {
                                xs: 'repeat(2, 1fr)',
                                sm: 'repeat(3, 1fr)',
                                md: 'repeat(4, 1fr)',
                                lg: 'repeat(6, 1fr)',
                                xl: 'repeat(8, 1fr)',
                            },
                            gap: { xs: 1, sm: 1.5 },
                            p: { xs: 0.5, sm: 1 },
                            width: '100%',
                        }}
                    >
                        {products.map((card, index) => (
                            <ProductCard key={card.alias || index} card={card} index={index} />
                        ))}
                    </Box>
                    {hasMoreProducts && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: { xs: 3, sm: 4 }, mb: { xs: 2, sm: 3 } }}>
                            <Button
                                className="btn btn-primary"
                                onClick={loadMoreProducts}
                                disabled={isLoadingMore}
                                startIcon={isLoadingMore ? <CircularProgress size={20} color="inherit" /> : null}
                                sx={{
                                    px: { xs: 4, sm: 6 },
                                    py: { xs: 1.5, sm: 2 },
                                    borderRadius: '24px',
                                    textTransform: 'none',
                                    fontSize: { xs: '16px', sm: '18px' },
                                    fontWeight: 700,
                                }}
                            >
                                {isLoadingMore ? 'Kraunama' : 'Rodyti daugiau'}
                            </Button>
                        </Box>
                    )}
                    {!hasMoreProducts && products.length > 0 && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: { xs: 3, sm: 4 }, mb: { xs: 2, sm: 3 } }}>
                            <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic', textAlign: 'center' }}>
                                You've seen all {totalElements} products
                            </Typography>
                        </Box>
                    )}
                </>
            )}
        </Box>
    );
};

export default ProductSection;